import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router';
import PropTypes from 'prop-types';
import queryString from 'querystring';

import './sagas';

import actions from './actions';

class VerifyEmail extends React.Component {
  componentDidMount() {
    const { uid, email, key } = queryString.decode(
      this.props.location.search.substr(1)
    );

    if (!uid || !email || !key) {
      return;
    }

    this.props.emailVerify(uid, email, key);
  }

  render() {
    return <Redirect to="/" />;
  }
}

VerifyEmail.propTypes = {
  emailVerify: PropTypes.func.isRequired,
  uid: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(
  undefined,
  actions
)(withRouter(VerifyEmail));
